// Auto-generated by Storyline Creator (Vite)

export default {
  "id": "fallen_grace",
  "title": "Fallen Grace",
  "coverImage": "",
  "requirements": [],
  "startScene": "start",
  "scenes": {
    "start": {
      "steps": [
        {
          "type": "page",
          "image": "/images/fallen_grace_1.png",
          "text": "Click to continue."
        },
        {
          "type": "choice",
          "image": "/images/fallen_grace_2.png",
          "prompt": "Drag to choose.",
          "left": {
            "label": "Give him a potion.",
            "if": [
              {
                "type": "hasResource",
                "key": "potions",
                "gte": 1
              }
            ],
            "effects": [
              {
                "type": "sanity",
                "delta": 5
              },
              {
                "type": "flag",
                "key": "give_potion",
                "value": true
              }
            ],
            "nextScene": "end",
            "nextStorylet": "repaired_hero"
          },
          "right": {
            "label": "Ignore him.",
            "if": [],
            "effects": [
              {
                "type": "sanity",
                "delta": -2
              },
              {
                "type": "flag",
                "key": "give_potion",
                "value": false
              }
            ],
            "nextScene": "scene_1",
            "nextStorylet": "fallen_hero"
          }
        }
      ]
    },
    "scene_1": {
      "steps": [
        {
          "type": "page",
          "image": "/images/fallen_grace_4.png",
          "text": "Click to continue."
        },
        {
          "type": "page",
          "image": "/images/fallen_grace_5.png",
          "text": "Click to continue."
        },
        {
          "type": "ending",
          "image": "/images/fallen_grace_6.png",
          "text": "Click to end.",
          "effects": [
            {
              "type": "startCombat",
              "encounterId": "undead-hero"
            }
          ]
        }
      ]
    },
    "end": {
      "steps": [
        {
          "type": "ending",
          "image": "/images/fallen_grace_3.png",
          "text": "Click to end.",
          "effects": []
        }
      ]
    }
  }
};
